// extracted by mini-css-extract-plugin
module.exports = {"logo":"NewHeader_logo__3uegW","pages":"NewHeader_pages__2OD30"};